export default __webpack_public_path__ + "static/media/logo_white.fa612749.svg";